import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2 cursor-pointer">
              <div className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center">
                <i className="ri-trophy-line text-xl text-white"></i>
              </div>
              <span className={`text-xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                TeamPro
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <a
                href="#features"
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                Features
              </a>
              <a
                href="#solutions"
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                Solutions
              </a>
              <a
                href="#equipment-store"
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                Equipment
              </a>
              <Link
                to="/orders"
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                Orders
              </Link>
              <Link
                to="/press"
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                Press Kit
              </Link>
              <Link
                to="/deploy-guide"
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                Deploy Guide
              </Link>
              <a
                href="#about"
                className={`font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                About
              </a>
              <button className="bg-teal-500 text-white px-6 py-2 rounded-lg font-semibold hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                Get Started
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`md:hidden p-2 rounded-lg transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-white pt-20">
          <div className="flex flex-col items-center space-y-6 p-6">
            <a
              href="#features"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-lg font-medium text-gray-700 hover:text-teal-500 transition-colors cursor-pointer"
            >
              Features
            </a>
            <a
              href="#solutions"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-lg font-medium text-gray-700 hover:text-teal-500 transition-colors cursor-pointer"
            >
              Solutions
            </a>
            <a
              href="#equipment"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-lg font-medium text-gray-700 hover:text-teal-500 transition-colors cursor-pointer"
            >
              Equipment
            </a>
            <Link
              to="/orders"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-lg font-medium text-gray-700 hover:text-teal-500 transition-colors cursor-pointer"
            >
              Orders
            </Link>
            <Link
              to="/press"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-lg font-medium text-gray-700 hover:text-teal-500 transition-colors cursor-pointer"
            >
              Press Kit
            </Link>
            <Link
              to="/deploy-guide"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-lg font-medium text-gray-700 hover:text-teal-500 transition-colors cursor-pointer"
            >
              Deploy Guide
            </Link>
            <a
              href="#about"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-lg font-medium text-gray-700 hover:text-teal-500 transition-colors cursor-pointer"
            >
              About
            </a>
            <button className="bg-teal-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
              Get Started
            </button>
          </div>
        </div>
      )}
    </>
  );
}
